import { render, staticRenderFns } from "./client-list-settings-modal.vue?vue&type=template&id=af16c84a&scoped=true"
import script from "./client-list-settings-modal.vue?vue&type=script&lang=js"
export * from "./client-list-settings-modal.vue?vue&type=script&lang=js"
import style0 from "./client-list-settings-modal.vue?vue&type=style&index=0&id=af16c84a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af16c84a",
  null
  
)

export default component.exports